function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  transform: "matrix(-1 0 0 1 60 30)",
  fill: "#CACACA",
  r: 30
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M60 60c-16.418 0-29.806-13.301-29.806-29.709H90C90 46.7 76.612 60 60 60z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30 30c0 16.568-13.325 30-30 30V0c16.675 0 30 13.431 30 30z",
  fill: "#343434"
});

function SvgLogoGrayscale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 60,
    viewBox: "0 0 90 60",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOTAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA5MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGVsbGlwc2Ugcng9IjMwIiByeT0iMzAiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDYwIDMwKSIgZmlsbD0iI0NBQ0FDQSIvPgo8cGF0aCBkPSJNNjAgNjBDNDMuNTgxOCA2MCAzMC4xOTM2IDQ2LjY5ODkgMzAuMTkzNiAzMC4yOTEzSDkwQzkwIDQ2LjY5ODkgNzYuNjExOSA2MCA2MCA2MFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0zMCAzMEMzMCA0Ni41Njg0IDE2LjY3NTQgNjAgMi42MjI2OGUtMDYgNjBMMCAwQzE2LjY3NTQgLTcuMjg5MDVlLTA3IDMwIDEzLjQzMTQgMzAgMzBaIiBmaWxsPSIjMzQzNDM0Ii8+Cjwvc3ZnPgo=";
export { SvgLogoGrayscale as ReactComponent };